import { createFileRoute } from '@tanstack/react-router';

import { PraetorPoliciesPage } from '~/app/praetors/policies/Policies';

export const Route = createFileRoute('/_app/home/praetors/$praetorId/policies/')({
	beforeLoad: () => ({
		getTitle: undefined
	}),
	component: function PraetorPolicies() {
		return <PraetorPoliciesPage />;
	}
});
